import { getOuterHeight, getOuterWidth } from '@flowio/browser-helpers';
export default function getDimensionValue(dimension, element) {
  return dimension === 'height' ? getOuterHeight(element, true) : getOuterWidth(element, true);
}